import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import {
  B1,
  FieldTitle,
  Icon,
  getTranslatedText,
  AccessControl,
  BackgroundIcon
} from '@nile/components';
import { APPROVAL_MAP, DeleteModal, HeaderTag } from '@nile/components/src';
import { TaskCard } from '@nile/projects/src/Components/Cards';
import {
  Avatar,
  Button,
  ButtonGroup,
  Card,
  Heading,
  Link,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { Edit } from '@styled-icons/material/Edit';
import envConfig from '@nile/home/src/Config/env';
import dompurify from 'dompurify';
import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { sortBy } from 'lodash';

class SOProcdureCascade extends Component {
  constructor(props) {
    super(props);
    this.sanitizer = dompurifier;
    this.state = {
      inputValue: '',
      value: [],
      selectedSOP: props.sops.length > 0 ? props.sops[0] : [],
      selectedItems: props.sops.length > 0 ? [props.sops[0].sopId] : [],
      clients: [],
      conditions: [
        {
          id: 1,
          items: [
            {
              name: 'group',
              items: [
                {
                  name: 'property',
                  type: 'string',
                  obj: { label: 'Ticket type', id: 128 }
                },
                {
                  name: 'operator',
                  type: 'string',
                  obj: { label: 'is', id: 234 }
                },
                {
                  name: 'value',
                  type: 'list',
                  obj: { label: 'Incident', id: 2314 }
                }
              ]
            },
            {
              name: 'operator',
              type: 'string',
              obj: { label: 'AND', id: 21 }
            },
            {
              name: 'group',
              items: [
                {
                  name: 'property',
                  type: 'string',
                  obj: { label: 'Category', id: 211 }
                },
                {
                  name: 'operator',
                  type: 'string',
                  obj: { label: 'is', id: 941 }
                },
                {
                  name: 'value',
                  type: 'list',
                  obj: { label: 'Server', id: 541 }
                }
              ]
            }
          ]
        }
      ],
      targetEsclationTime: [],
      technicianList: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.sops.find((el) => el.sopId === state.selectedSOP.sopId)) {
      return {
        ...state,
        selectedSOP: props.sops.length > 0 ? props.sops[0] : [],
        selectedItems: props.sops.length > 0 ? [props.sops[0].sopId] : []
      };
    }
  }

  renderSubItem = (item) => {
    this.setState({ selectedSOP: item });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
    }
  };

  handleSOPChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  deleteSOP = (id) => {
    this.props.deleteSOP({
      variables: { id }
    });
  };

  render() {
    const { selectedSOP, selectedItems } = this.state;
    const { intl, sops } = this.props;
    const processedAllItems = processData(sops, 'sopId');

    const sortedTaskTemplateList = sortBy(
      selectedSOP.taskTemplateList,
      'taskOrder'
    );

    return (
      <>
        <div className="fx white-transparent-bg ch-20">
          <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleSOPChange}
                />
              </div>
              {/* <SearchInput className="p16"></SearchInput> */}
              <div className="ch-50 pb20 scroll">
                <ResourceList
                  items={sops}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item, index) => {
                    const { sopId, name, technicians, clients } = item;
                    return (
                      <ResourceItem
                        id={sopId}
                        accessibilityLabel={`View details for ${name}`}
                        customClassName="list-no-pad"
                      >
                        <div
                          className="fw list-item"
                          onClick={this.renderSubItem.bind(this, item)}
                        >
                          {!technicians && !clients && (
                            <TextStyle variation="strong">{name} </TextStyle>
                          )}
                        </div>
                        {item.uioptions && item.uioptions.length > 0 ? (
                          <div className="iconHolder">
                            <SVGIcon name="ArrowRight" />
                          </div>
                        ) : (
                          ''
                        )}
                      </ResourceItem>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {selectedSOP && (
            <div className="fx p2040 scroll w70">
              <div data-qa="sopEdit" className="full-width scroll">
                <div className="flex">
                  <div className="fx2 mt-10 pl10">
                    <Heading element="h2">{selectedSOP.name}</Heading>
                    <p className="sop-desc mt-10">{selectedSOP.description}</p>
                  </div>
                  <div
                    className="fx jend self-start admin-view-action"
                    data-qa="runbookEdit"
                  >
                    <ButtonGroup>
                      <AccessControl
                        roleToCheck="runbook.delete"
                        render={
                          <DeleteModal
                            description={getTranslatedText(
                              intl,
                              'admin.runbook.delete.confirm'
                            )}
                            handleDeleteConfirmation={() =>
                              this.deleteSOP(selectedSOP.sopId)
                            }
                            title={getTranslatedText(
                              intl,
                              'admin.runbook.delete.text'
                            )}
                          />
                        }
                      />
                      <AccessControl
                        roleToCheck="runbook.edit"
                        render={
                          <div className="fx jend actr SOP-Edit-Btn">
                            <Link
                              url={
                                '#/onboard/soplist/' +
                                selectedSOP.sopId +
                                '/edit'
                              }
                            >
                              <Button
                                secondary
                                icon={<SVGIcon name="Edit" />}
                              />
                            </Link>
                          </div>
                        }
                      />
                    </ButtonGroup>
                  </div>
                </div>
                <div className="col SOP-Page-Content ch-90 scroll">
                  {selectedSOP && (
                    <div className="rounded-4px p12 scroll img-mw100">
                      <Heading element="h4" weight="Bold">
                        <FormattedMessage id="admin.runbook.pg1.h2.associatetasks" />
                      </Heading>

                      {sortedTaskTemplateList.length ? (
                        sortedTaskTemplateList.map((el, idx) => {
                          return (
                            <div className="mt10">
                              <TaskCard
                                task={el}
                                index={idx}
                                disableActions
                                disableEdit
                                disableView
                                enableDrag={false}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <B1>
                          <FormattedMessage id="admin.runbook.noTasks" />
                        </B1>
                      )}
                    </div>
                  )}
                  {selectedSOP && (
                    <div className="rounded-4px p12 scroll img-mw100">
                      <Heading element="h4" weight="Bold">
                        <FormattedMessage id="admin.runbook.pg1.h2.Approvals" />
                      </Heading>
                      <div className="flex mt10 wrap">
                        {selectedSOP?.approverList ? (
                          selectedSOP?.approverList?.map((el) => {
                            if (el.placeHolder) {
                              return (
                                <div className="flex center mb-20 fb-33">
                                  <div className="mr-10">
                                    <Avatar
                                      name={`${getTranslatedText(
                                        intl,
                                        el.placeHolder
                                      )}`}
                                      size="extraSmall"
                                      customer
                                    />
                                  </div>
                                  <div>
                                    <FieldTitle className="title">{`${getTranslatedText(
                                      intl,
                                      el.placeHolder
                                    )}`}</FieldTitle>
                                  </div>
                                </div>
                              );
                            } else if (el.userTypeRole) {
                              return (
                                <div className="flex center mb-20 fb-33">
                                  <div className="mr16">
                                    <Avatar size="extraSmall" customer />
                                  </div>
                                  <div>
                                    <FieldTitle className="title">{`${el.userTypeRole.name}`}</FieldTitle>
                                  </div>
                                </div>
                              );
                            }
                          })
                        ) : (
                          <B1>
                            {' '}
                            <FormattedMessage id="admin.runbook.noUsers" />
                          </B1>
                        )}
                      </div>
                    </div>
                  )}
                  {selectedSOP && (
                    <div className="rounded-4px p12 scroll img-mw100">
                      <Heading element="h4" weight="Bold">
                        <FormattedMessage id="admin.runbook.pg1.h2.replyTemp" />
                      </Heading>
                      {selectedSOP.emailTemplateList?.length ? (
                        selectedSOP.emailTemplateList.map((item) => {
                          return (
                            <div className="SOP-Email-Templates pnone">
                              <h5> {item.name} </h5>
                              <p>
                                <div
                                  className="message-content word-break"
                                  dangerouslySetInnerHTML={{
                                    __html: this.sanitizer(item.content)
                                  }}
                                />
                              </p>
                            </div>
                          );
                        })
                      ) : (
                        <div className="mt-10">
                          <B1>
                            {' '}
                            <FormattedMessage id="admin.runbook.noTemp" />
                          </B1>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default injectIntl(SOProcdureCascade);
